.bottom-divider{margin-bottom:1em;padding-bottom:1em;border-bottom:1px solid #d8d8d8}.titles{font-weight:500}
/*# sourceMappingURL=admission-popup.component-OUHVVOTB.css.map */
